import styled from 'styled-components';
import * as PropTypes from 'prop-types';
import { media } from '../styledMedia';
import { Table } from '@mui/material';

//Material-Ui Table component with responsive design, can horizontally scroll in media.xs

/**
 * @param {Number} itemsnum - number of items per table row
 */
const StyledScrollableTable = styled(Table)`
  && {
    ${media.xs`
      white-space: nowrap;
      th {
        width:${({ itemsnum }) => 100 / itemsnum}%;
        padding-bottom: 8px;
      }
  `}
  }
`;

StyledScrollableTable.propTypes = {
  itemsnum: PropTypes.number.isRequired
};

export default StyledScrollableTable;
